import { render } from "./post-confirm-metfone-service.vue?vue&type=template&id=1cd34219"
import script from "./post-confirm-metfone-service.vue?vue&type=script&lang=js"
export * from "./post-confirm-metfone-service.vue?vue&type=script&lang=js"

import "./post-confirm-metfone-service.vue?vue&type=style&index=0&id=1cd34219&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__